import { formatReportDate, formatReportDateDistanceInWords } from "../utils/TableCellDataFormatters";
export const currencySignsFormatter = (data, helpers) => {
  const {
    getCurrencySigns
  } = helpers;
  const currencySignRegex = RegExp(`[${getCurrencySigns().join("")}]`);
  return Number(data.toString().replace(currencySignRegex, "").trim()).toFixed(2);
};
export const csvDateFormatter = (data, helpers, config) => {
  const {
    timeZone
  } = helpers.managerProfile;
  let includeSeconds = false,
    showDateOnly = true,
    customFormat = "";
  if (config) {
    includeSeconds = config.includeSeconds;
    showDateOnly = config.showDateOnly;
    customFormat = config.customFormat;
  }
  return formatReportDate(data, {
    includeSeconds,
    showDateOnly,
    customFormat
  }, timeZone);
};
export const downloadFormatterVariants = {
  csvDateWithMinutes: {
    downloadFormatter: (data, helpers) => csvDateFormatter(data, helpers, {
      includeSeconds: false,
      showDateOnly: false,
      customFormat: ""
    })
  },
  csvDateWithSeconds: {
    downloadFormatter: (data, helpers) => csvDateFormatter(data, helpers, {
      includeSeconds: true,
      showDateOnly: false,
      customFormat: ""
    })
  }
};
export const dateToWords = (data, helpers) => {
  const {
    timeZone
  } = helpers.managerProfile;
  const {
    formattedDate
  } = formatReportDateDistanceInWords(data, timeZone);
  return formattedDate;
};
export const onDownloadFormatter = (buildHead, buildBody, columns, data) => (columnDefs, helpers, config) => {
  return buildHead(columns) + buildBody(data.map(row => {
    Object.keys(columnDefs).map((columnKey, index) => {
      const col = columnDefs[columnKey];
      if (col.downloadFormatter) {
        row.data[index] = col.downloadFormatter(row.data[index], helpers, config);
      }
    });
    return row;
  }));
};